import { Steps, Tabs, Tooltip } from "antd";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  CustomerShipmentDetails,
  customerShipmentDetails,
  customerShipmentTrack,
  shipment_history,
} from "../../actions/shipmentNPayment";
import close from "../../assets/cancel.svg";
import xl from "../../assets/excel_icon.png";
import PopupComponent from "../../common/Popup";
import { NavWrap } from "../ShopForTyres";
// import attachment from "../../assets/paperclip.svg";
// import refresh from "../../assets/refresh.svg";
import { InfoCircleFilled } from "@ant-design/icons";
import ProdDetailTable from "./ProdDetailTableShip";
import ShipmentTrackPopup from "./ShipmentTrackPopup";
import { ScaleLoader } from "react-spinners";
import { hasOnlyView } from "../../config/helper";  

const { Step } = Steps;
const { TabPane } = Tabs;
const isMyOrdersReadOnly = hasOnlyView("my_orders");

export const ship_status = {
  // 0: "Planned",
  1: "Planning completed",
  2: "Check-In",
  3: "Loading start",
  4: "Loading end",
  // 5: "Shipment completion",
  6: "Shipment start",
  7: "Shipment end",
};

export const planned_key = {
  0: {
    date: "",
    time: "",
  },
  1: {
    date: "",
    time: "",
  },
  2: {
    date: "PL_DATE_CHECKIN",
    time: "PL_TIME_CHECKIN",
  },
  3: {
    date: "PL_LOAD_START",
    time: "PL_LOAD_START_TIME",
  },
  4: {
    date: "PL_LOAD_END_DATE",
    time: "PL_LOAD_END_TIME",
  },
  5: {
    date: "PL_SHP_CMPL_DATE",
    time: "PL_SHP_CMPL_TIME",
  },
  6: {
    date: "PL_SHIP_START_DATE",
    time: "PL_SHIP_START_TIME",
  },
  7: {
    date: "PL_SHIP_END_DATE",
    time: "PL_SHIP_END_TIME",
  },
};

export const acutal_key = {
  0: {
    date: "",
    time: "",
  },
  1: {
    date: "PLANNING_END",
    time: "",
  },
  2: {
    date: "ACT_CHECK_IN_DATE",
    time: "ACT_CHECK_IN_TIME",
  },
  3: {
    date: "ACT_LOAD_START_DAT",
    time: "ACT_LOAD_START_TIME",
  },
  4: {
    date: "ACT_LOAD_END_DATE",
    time: "ACT_LOAD_END_TIME",
  },
  5: {
    date: "ACT_SHIP_CMPL_DATE",
    time: "ACT_SHIP_CMPL_TIME",
  },
  6: {
    date: "ACT_SHIP_START_DATE",
    time: "ACT_SHIP_START_TIME",
  },
  7: {
    date: "ACT_SHIP_END_DATE",
    time: "ACT_SHIP_END_TIME",
  },
};

export const ship_status_text = {
  0: "Planned",
  1: "Planned",
  2: "In Transit",
  3: "In Transit",
  4: "In Transit",
  5: "Completed",
  6: "In Transit",
  7: "Completed",
};
const MyShipmentWrap = (props) => {
  const history = useHistory();
  const location = useLocation();
  return (
    <div className="order-wrap">
      <div className="flex-between">
        <div className="left-sec">
          <label>{props.label}</label>
        </div>
        <div className="right-sec">
          {props.showInvoice && (
            <button className={`re-order`} onClick={props.invoice} disabled={isMyOrdersReadOnly}>
              Invoice
            </button>
          )}
          {/* <button className={`re-order`} onClick={props.showTrackOrder}>
            Track Order
          </button> */}

          {props.hasShipment && (
            <button
              disabled={isMyOrdersReadOnly}
              className="re-order"
              onClick={props.preAdvise}
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              Pre-Shipment {props.isPending ? "Approval" : "Approved"}{" "}
              {props.isPending ? (
                <Tooltip
                  placement="bottom"
                  title={
                    "Note: Please note that this shipment will be automatically approved after 48 hours."
                  }
                >
                  <InfoCircleFilled className="mlHalf" />
                </Tooltip>
              ) : null}
            </button>
          )}
          {/* <p className="note" style={{ position: "absolute" }}>Note: Please note that this shipment will be automatically approved after 48 hours.</p> */}
          {/* <button>
                More
                <img src={down} alt="icon" width={10} className="ml" />
              </button>
              <button>
                <img src={refresh} alt="icon" width={12} className="mr" />
                Sync Information
              </button> */}

          <span
            className="close"
            onClick={() => {
              if (location?.state?.from === "shipments") {
                history.push("/track-shipments", {
                  filters: location?.state?.filters,
                });
              } else {
                history.push("/track-shipments");
              }
            }}
          >
            <img src={close} alt="icon" width={18} />
          </span>
        </div>
      </div>
      {props.children}
    </div>
  );
};

const ShipmentDetail = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const shipment_track = useSelector(
    (state) => state?.shipNPay?.customer_shipment_track?.data?.[0]
  );
  const shipment_details = useSelector(
    (state) => state?.shipNPay?.customer_shipment_details?.data
  );

  const shipment_detail_loading = useSelector(
    (state) => state?.shipNPay?.customer_shipment_details?.loading
  );

  const shipment_history_res = useSelector(
    (state) => state?.shipNPay?.shipment_history?.data
  );

  // const orderHistory = useSelector(
  //   (state) => state?.orders?.order_history?.data
  // );

  const [tab, setTab] = useState("2");
  const [open, setOpen] = useState(false);
  const [openHis, setOpenHis] = useState(false);
  const [products, setProducts] = useState([]);
  const [shipment_detail, setShipment_detail] = useState({});
  const history = useHistory();
  const params = useParams();

  const callShipmentDetails = (shipment_no) => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    dispatch(
      customerShipmentDetails({
        ...obj,
        do_number: shipment_no,
      })
    );
    if (location.state?.shipment_no) {
      dispatch(
        shipment_history({
          ...obj,
          shipment_no,
        })
      );
      dispatch(
        customerShipmentTrack({
          ...obj,
          shipment_no,
        })
      );
    }
  };

  useEffect(() => {
    dispatch({
      type: CustomerShipmentDetails.RESET,
    });
    callShipmentDetails(location?.state?.shipment_no ?? params?.id);
    return () => {
      setShipment_detail({});
      dispatch({
        type: CustomerShipmentDetails.RESET,
      });
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      shipment_details &&
      shipment_details.length > 0 &&
      Array.isArray(shipment_details)
    ) {
      setShipment_detail(shipment_details?.[0]);
      let arr = [];
      shipment_details?.forEach((ele) => {
        arr.push({
          SKU: ele.Matnr,
          Pattern: ele.Maktx,
          Size: "",
          "Unit Price": parseFloat(ele.Netpr).toFixed(2),
          Quantity: parseInt(ele.Kwmeng),
          SONumber: parseInt(ele.SoNumber),
          PONumber: ele.Bstnk,
          DeliveryNo: ele.DeliveryNo,
          DeliveredQty: parseInt(ele.DeliveredQty),
          Preshipstatus: ele.Preshipstatus,
          OpenQty: parseInt(ele.OpenQty),
          ZfillDel: parseFloat(ele.ZfillDel),
          ZfillTot: parseFloat(ele.ZfillTot),
          Amount:
            parseFloat(ele.DeliveredQty).toFixed(2) *
            parseFloat(ele.Netpr).toFixed(2),
        });
      });
      setProducts(arr);
      if (!location.state?.shipment_no)
        dispatch(
          customerShipmentTrack({
            email: localStorage.getItem("email"),
            shipment_no: shipment_details?.[0]?.ShipNo,
          })
        );
    }
    // eslint-disable-next-line
  }, [shipment_details]);

  const order_status = {
    Completed: "success-text",
    "In Transit": "warn-text",
    Planning: "warn-text",
  };

  // const Preshipstatus = {
  //   "A": "Approved",
  //   "S": "Auto Approved",
  //   "P": "Pending Approval"
  // }
  return (
    <NavWrap>
      <div className="card2 prod">
        <MyShipmentWrap
          label={"Shipments"}
          showInvoice={shipment_detail?.InvoiceNo}
          hasShipment={shipment_detail?.ShipNo}
          showTrackOrder={() => {
            setOpen(true);
          }}
          invoice={() => {
            history.push("/payment-doc/" + shipment_detail?.InvoiceNo, {
              order_no: shipment_detail?.OrderId,
              time: moment(shipment_detail?.SoDate, "YYYYMMDD").format(
                "DD MMM, YYYY"
              ),
              billNo: shipment_detail?.InvoiceNo,
            });
          }}
          isPending={products?.[0]?.Preshipstatus === "P"}
          preAdvise={() => {
            history.push("/shipment-doc/" + shipment_detail?.ShipNo, {
              delNo: location?.state?.shipment_no,
              invoice_no: shipment_detail?.InvoiceNo,
              isPending: products?.[0]?.Preshipstatus === "P",
              do_number: location.state?.do_number,
              order_id: shipment_detail?.OrderId,
              time: moment(shipment_detail?.SoDate, "YYYYMMDD").format(
                "DD MMM, YYYY"
              ),
            });
          }}
        >
          {shipment_detail_loading ? (
            <div className="details">
              <div className="flex-center">
                <ScaleLoader color={"#2f2d51"} />
              </div>
            </div>
          ) : shipment_detail?.ShipNo ? (
            <div className="details">
              <div className="flex-between">
                <div>
                  <div>
                    <span
                      className={`status ${
                        order_status[
                          ship_status_text[shipment_detail?.ShipStatus]
                        ]
                      }`}
                    >
                      {ship_status_text[shipment_detail?.ShipStatus]}
                    </span>
                  </div>
                  <div>
                    <span className="nm large">
                      Shipment ID - #{shipment_detail?.ShipNo}
                    </span>
                  </div>
                  <div>
                    <span className="nm">
                      Container No: {shipment_detail?.Container}
                    </span>
                  </div>
                  <div>
                    <span className="nm">
                      Vessel Name: {shipment_detail?.VesselNo}
                    </span>
                  </div>
                  <div>
                    <span className="nm">
                      {"ETD Date: " +
                        (shipment_detail?.EtdDate === "00000000"
                          ? ""
                          : moment(shipment_detail?.EtdDate, "YYYYMMDD").format(
                              "DD/MM/YYYY"
                            ))}
                    </span>
                  </div>
                  <div>
                    <span className="nm">
                      {"ETA Date: " +
                        (shipment_detail?.EtaDate === "00000000"
                          ? ""
                          : moment(shipment_detail?.EtaDate, "YYYYMMDD").format(
                              "DD/MM/YYYY"
                            ))}
                    </span>
                  </div>
                  {/* <div>
                  <span className="nm">
                    Freight Provider : {""}
                     {shipment_detail?.name} <br />
                    <span className="light">{shipment_detail?.email}</span>
                  </span>
                </div> */}
                </div>
              </div>
            </div>
          ) : (
            !shipment_detail_loading &&
            shipment_details?.message?.length === 0 && (
              <div className="flex-center m4">
                <div className="content">
                  <h1 className="nm large">Shipment Not Found</h1>
                  <span>
                    Sorry, we couldn't find the shipment you were looking for.
                  </span>
                  <span>Please check the shipment number.</span>
                  <span
                    className="link"
                    onClick={() => {
                      history.push("/track-shipments");
                    }}
                  >
                    Go Back to Shipments
                  </span>
                </div>
              </div>
            )
          )}
          {shipment_detail?.ShipNo && (
            <div className="tabs mt1">
              <Tabs
                defaultActiveKey={"1"}
                onTabClick={(val) => {
                  setTab(val);
                }}
              >
                <TabPane active={tab} tab="Product Details" key="1">
                  <ProdDetailTable
                    data={products}
                    order={{
                      total_price: _.sumBy(products, "Amount"),
                      total_quantity: _.sumBy(products, "Quantity"),
                    }}
                    isPending={location?.state?.isPending}
                    downloadIcon={
                      <div
                        style={{
                          fontSize: 14,
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        <img src={xl} width={30} alt="" /> Download as Excel
                      </div>
                    }
                    // isEdit={false}
                    // products={products}
                    // setProducts={setProducts}
                  />
                </TabPane>
                <TabPane active={tab} tab="Shipment Status" key="2">
                  <div className="status">
                    <div className="ml1 mt1">
                      <Steps
                        direction="vertical"
                        progressDot
                        current={Number(shipment_track?.transport_status) + 1}
                      >
                        {Object.keys(ship_status).map((ele) => (
                          <Step
                            title={
                              <div className="box">
                                {ship_status[ele]}
                                {/* eslint-disable-next-line  */}
                                {ele == 6 && (
                                  <span
                                    className="ml2 cursor evision"
                                    onClick={() => {
                                      setOpenHis(true);
                                    }}
                                  >
                                    Real Time Shipment Status
                                  </span>
                                )}
                                <div className="d-flex w100">
                                  {parseInt(
                                    shipment_track?.[planned_key[ele].date]
                                  ) ? (
                                    <span>
                                      Planned:{" "}
                                      {parseInt(
                                        shipment_track?.[planned_key[ele].date]
                                      )
                                        ? moment(
                                            shipment_track?.[
                                              planned_key[ele].date
                                            ],
                                            "YYYYMMDD"
                                          ).format("MMM DD, YYYY")
                                        : " - "}
                                      &nbsp;
                                      {parseInt(
                                        shipment_track?.[planned_key[ele].time]
                                      )
                                        ? moment(
                                            shipment_track?.[
                                              planned_key[ele].time
                                            ],
                                            "hhmmss"
                                          ).format("HH:mm")
                                        : ""}
                                    </span>
                                  ) : null}
                                  <span>
                                    Actual: &nbsp;
                                    {parseInt(
                                      shipment_track?.[acutal_key[ele].date]
                                    )
                                      ? moment(
                                          shipment_track?.[
                                            acutal_key[ele].date
                                          ],
                                          "YYYYMMDD"
                                        ).format("MMM DD, YYYY")
                                      : " - "}
                                    &nbsp;
                                    {parseInt(
                                      shipment_track?.[acutal_key[ele].time]
                                    )
                                      ? moment(
                                          shipment_track?.[
                                            acutal_key[ele].time
                                          ],
                                          "hhmmss"
                                        ).format("HH:mm")
                                      : ""}
                                  </span>
                                </div>
                              </div>
                            }
                          />
                        ))}
                      </Steps>
                    </div>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          )}
        </MyShipmentWrap>
      </div>
      <ShipmentTrackPopup
        open={open}
        setOpen={setOpen}
        shipment_track={shipment_track}
        setOpenHis={setOpenHis}
        shipment_detail={shipment_detail}
      />
      <PopupComponent open={openHis} width={920}>
        <div className="popup-wrap order-detail shipment-history">
          <img
            src={close}
            alt="close"
            width={14}
            style={{
              position: "absolute",
              right: 20,
              top: 10,
              cursor: "pointer",
            }}
            onClick={() => setOpenHis(false)}
          />
          <div className="flex-start">
            <h2
              style={{
                fontSize: "1.2rem",
                fontWeight: 600,
              }}
            >
              Real Time Shipment Status - #{shipment_detail?.ShipNo}
            </h2>
          </div>
          <div>
            <div className="table">
              <div className="thead">
                <div className="tr">
                  <div className="td w20">{"Shipment No."}</div>
                  <div className="td w40">{"Date"}</div>
                  <div className="td w40">{"Status"}</div>
                </div>
              </div>
              <div className="tbody">
                {shipment_history_res?.history_list?.map((ele) => {
                  return (
                    <div className="tr">
                      <div className="td w20">{ele.Tknum}</div>
                      <div className="td w40">
                        {moment(ele.Erdat).format("DD, MMM YYYY, HH:mm")} GMT
                        +8:00
                      </div>
                      <div className="td w40">{ele.Status}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </PopupComponent>
    </NavWrap>
  );
};

export default ShipmentDetail;
